

export const webVideoHelper = {
    youtubeURLFormat: /(https:\/\/www\.youtube\.com\/)(embed\/|watch\?v=)?([^"']*)/,
    vimeoURLFormat: /(https:\/\/(www\.)?vimeo\.com\/)([^"']*)/,
    youtubeShareFormat: /(https:\/\/youtu\.be\/)([^"']*)/,

    youtubeEmbedURLPrefix: 'https://www.youtube.com/embed/',
    vimeoEmbedURLPrefix: 'https://player.vimeo.com/video/',

    /**
     * Checks if a URL is correctly formatted for Youtube
     * @param url A url
     */
    isYoutubeURL(url: string): boolean {
        if (this.youtubeURLFormat.test(url)) {
            return true;
        } else if (this.youtubeShareFormat.test(url)) {
            return true;
        }
        return false;
    },

    /**
     * Checks if a URL is correctly formatted for Vimeo
     * @param url A url
     */
    isVimeoURL(url: string): boolean {
        if (this.vimeoURLFormat.test(url)) {
            return true;
        }

        return false;
    },

    /**
     * Turns any Youtube URL into a Youtube Embed URL
     * If the URL is not a valid Youtube URL, then it will return an empty string
     * @param url A Youtube URL
     * @return A Youtube Embed URL
     */
    getYoutubeEmbedURL(url: string): string {
        let youtubeId = '';
        if (!url) {
            return '';
        }
        let matches = url.match(this.youtubeURLFormat);
        if (matches) {
            youtubeId = matches[3];
            if (youtubeId.startsWith('shorts')) {
                youtubeId = youtubeId.split('/')[1];
            }
        } else {
            matches = url.match(this.youtubeShareFormat);
            if (matches) {
                youtubeId = matches[2];
            }
        }
        if (!youtubeId) {
            return '';
        }
        return this.youtubeEmbedURLPrefix + youtubeId.replace('&', '?');
    },

    /**
     * Turns any Vimeo URL into a Vimeo Embed URL
     * If the URL is not a valid Vimeo URL, then it will return an empty string
     * @param url A Vimeo URL
     * @return A Vimeo Embed URL
     */
    getVimeoEmbedURL(url: string): string {
        let vimeoId = '';
        if (!url) {
            return '';
        }
        const matches = url.match(this.vimeoURLFormat);
        if (matches) {
            vimeoId = matches[3];
        }

        if (!vimeoId) {
            return '';
        }
        return this.vimeoEmbedURLPrefix + vimeoId;
    },


    /**
     * Turns an URL into a Vimeo or Youtube Embed URL
     * If the URL is not a valid Vimeo URL, then it will return an empty string
     * @param url A Vimeo or Youtube URL
     * @return A Vimeo or Youtube Embed URL
     */
    getEmbedUrl(url: string): string {
        if (this.isYoutubeURL(url)) {
            return this.getYoutubeEmbedURL(url);
        } else if (this.isVimeoURL(url)) {
            return this.getVimeoEmbedURL(url);
        }

        return '';
    }
};
